import { addNotification } from "@/redux/reducer/notificationSlice";
import { Dispatch } from "@reduxjs/toolkit";
import Router from "next/router";

interface QueuedRequest {
  url: string;
  options: RequestInit;
  dispatch?: Dispatch<any>;
}

let requestQueue: QueuedRequest[] = [];
let isProcessingQueue = false;

export const retryQueuedRequests = async () => {
  if (!navigator.onLine || isProcessingQueue || requestQueue.length === 0)
    return;

  isProcessingQueue = true;

  const requestsToProcess = [...requestQueue];
  requestQueue = [];

  try {
    await Promise.all(
      requestsToProcess.map(async ({ url, options, dispatch }) => {
        try {
          const response = await fetch(url, options);
          if (response.ok) {
            return;
          }
        } catch (error) {
          console.error("Error processing queued request:", error);
        }
      })
    );
  } finally {
    isProcessingQueue = false;
  }
};

const apiFetch = async (url: string, options: RequestInit = {} ,dispatch?: Dispatch<any>) => {
  if (!navigator.onLine) {
    if (!requestQueue.some((req) => req.url === url)) {
      if (!dispatch) {
        requestQueue.push({ url, options });
      } else {
        requestQueue.push({ url, options, dispatch });
        dispatch(
          addNotification({
            type: "error",
            title: "Connection Error",
            subtitle: "Connection lost. Please check your internet connection.",
          })
        );
      }
    }
    return {
        ok: false,
      error: "Connection lost. Please check your internet connection.",
      code: 598,
            status: 598
    };
  }

  try {
    const res = await fetch(url, options);
    if (res.status === 401 &&  !url.startsWith('/api/auth')) {
      Router.replace("/signin", undefined, { locale: Router.locale });
      return;
    } else if (!res.ok) {
      const errorData = await res.json();
      const err = { responseOk: res.ok, error: errorData.error };
      return err;
    }

    return await res.json();
  } catch (error: any) {
    if (error.message === "Failed to fetch") {
      if (!requestQueue.some((req) => req.url === url)) {
        requestQueue.push({url, options, dispatch });
      }
    }
    return { error: error.message };
  }
};


export default apiFetch;
